import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import type { AgentSummarySource } from "../models/AgentSummary";
import sourceArrowSvg from '../assets/source-arrow.svg'

@customElement("facs-source")
export class Source extends LitElement {
    @property()
    source: AgentSummarySource | undefined;

    @property({ type: Boolean, reflect: true })
    multiple = false;

    render() {
        return html`
            <a href="${this.source?.url}" target="_blank" rel="noopener noreferrer">
                <div class="source-card">
                    <div class="content">
                        <p class="title">${this.source?.title}</p>
                        <div class="body">${this.source?.excerpt}</div>
                    </div>
                    <img src="${sourceArrowSvg}" class="icon" alt="" />
                </div>
            </a>
        `;
    }

    static styles = css`
        a {
            text-decoration: none;
            color: inherit;
        }

        .source-card {
            border-radius: 0.75rem;
            box-shadow: 0 0.125rem 0.25rem 0 rgba(0,0,0,0.15);
            padding: 0.625rem 1rem 0.625rem 0.625rem;
            display: flex;
            gap: 0.625rem;
            height: 100%;
            box-sizing: border-box;
            justify-content: space-between;

            .content {
                display: flex;
                flex-direction: column;
                justify-content: center;

                .title {
                     display: -webkit-box;
                     -webkit-box-orient: vertical;
                     -webkit-line-clamp: 2;
                     overflow: hidden;
                     line-height: 2rem;
                     font-size: 1.125rem;
                     letter-spacing: 0.01125rem;
                     color: var(--theme-primary, #0f2144);
                     font-weight: 600;
                     margin: 0 0 0.25rem 0;
                }

                .body {
                     display: -webkit-box;
                     -webkit-box-orient: vertical;
                     -webkit-line-clamp: 2;
                     overflow: hidden;
                     font-size: 1rem;
                     color: #555555;
                     line-height: 1.75rem;
                }
            }

            .icon {
                width: 0.75rem;
            }
        }

        .body {
           
        }

        @media (max-width: 840px) {
            .title {
                font-size: 1rem;
                line-height: 
            }
        }

        @media (min-width: 840px) {
            :host([multiple]) .content {
                justify-content: flex-start;
            }
        }
    `;
}